import heroImage from '../images/hero.jpg';
import heroImageAlt from '../images/hero-bg.jpg';
export default function () {
  return (
    <div className="xl:block relative z-[40] h-[70vh]">
      {/* <AspectRatio ratio={3/2} className=""> */}
        <div className="absolute inset-0">

          <img src={heroImageAlt} className="w-full h-full object-cover object-center" alt="Шарарам" />
        </div>
      {/* </AspectRatio> */}
      <div className="container mx-auto relative z-[999999] h-full flex flex-col justify-center px-4 xl:px-0">
        <div className="text-[40px]/10 xl:text-[100px]/20 font-bold text-white font-thin">
          <span className="font-medium text-[50px] xl:text-[120px] text-purple-300_ text-white drop-shadow font-bold">Шарарам &mdash;</span> <br/>студия <br/>аэродизайна</div>
        <hr className="w-30 my-20" />
        <div className="text-white text-2xl font-light">
          готовые решения / фотозоны / шары / оформление праздников / скидки
        </div>
      </div>
    </div>
  )
}